import * as _ from "lodash";
import { chevronDownOutline } from "ionicons/icons";
import React, { useState, useEffect } from "react";
import { IonLabel, IonInput, IonList, IonIcon, IonSpinner } from "@ionic/react";

import "./MBDropdownSelect.scss";
import { isMobile } from "../../functions/common";

export interface MBDropdownSelectOption {
  id: string;
  name: string;
  metadata?: any;
}
interface MBDropdownSelectProps {
  label?: string;
  value: string;
  onChange?: (value: string) => void;
  onSelectItem?: (item: MBDropdownSelectOption) => void;
  options: MBDropdownSelectOption[] | null;
  selectFromOptionsRequired?: boolean;
  readonly?: boolean;
  error?: string;
  disabled?: boolean;
  disableTab?: boolean;
  emptyOptionLabel?: string;
  placeholder?: string;
  sorted?: boolean;
  mode?: "cancer";
  className?: string;
}
export const MBDropdownSelect = (props: MBDropdownSelectProps) => {
  const {
    label,
    value,
    onChange,
    onSelectItem,
    error,
    options,
    selectFromOptionsRequired,
    disableTab,
    disabled,
    readonly,
    emptyOptionLabel,
    placeholder,
    sorted = false,
    mode,
    className,
  } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [listOptions, setListOptions] = useState(
    null as MBDropdownSelectOption[] | null
  );
  const [rawOptions, setRawOptions] = useState([] as MBDropdownSelectOption[]);
  const [itemGettingClicked, setItemGettingClicked] = useState(false);

  useEffect(() => {
    if (options !== undefined && !_.isNull(options)) {
      const newOptionsIdentifier = options.map((option) => option.id).join("");
      const oldOptionsIdentifier = rawOptions
        .map((option) => option.id)
        .join("");

      if (newOptionsIdentifier !== oldOptionsIdentifier) {
        const dropdownOptions = sorted
          ? _.sortBy(options, "name", "desc")
          : options;

        const cancerOptions = _.cloneDeep(dropdownOptions);

        //unshift to make the if cancer mode value to put first the i dont know
        cancerOptions.unshift({
          id: "0",
          name: "i dont know...",
        });

        setRawOptions(mode === "cancer" ? cancerOptions : dropdownOptions);
        if (_.isEmpty(value)) {
          setListOptions(null);
        }
      }
    } else {
      setRawOptions([]);
      setListOptions(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return (
    <>
      <div className="mb-dropdown-select-item ion-no-padding ion-no-margin">
        {label !== undefined && (
          <IonLabel
            className={`mb-dropdown-select-label ${
              isMobile() && "mobile"
            } mb-paragraph bold ${hasFocus && !readonly && "has-focus"} ${
              !!error && "has-error"
            }`}
            position="floating"
          >
            {label}
          </IonLabel>
        )}
        <div className="mb-dropdow-select-input-list-container">
          <IonInput
            {...(readonly !== undefined && { readonly: readonly })}
            className={`mb-dropdown-select-input ${hasFocus && "has-focus"} ${
              !!error && "has-error"
            } mb-body ${!!className ? className : ""}`}
            {...(placeholder !== undefined && { placeholder })}
            type="text"
            value={value}
            onKeyDown={(event) => {
              if (event.keyCode === 13) {
                setIsOpen(false);
              } else if (event.keyCode === 27) {
                setIsOpen(false);
              }
            }}
            onClick={() => {
              setIsOpen(true);
            }}
            onIonChange={(event) => {
              if (onChange !== undefined) {
                const strValue = event.detail.value || "";
                onChange(strValue);

                const filteredOptions = _.filter(
                  rawOptions,
                  (option) =>
                    option.name
                      .trim()
                      .toLowerCase()
                      .indexOf(strValue.trim().toLowerCase()) !== -1
                );

                const hasExactSearch =
                  filteredOptions.length === 1 &&
                  filteredOptions[0].name === strValue;

                setListOptions(
                  !_.isNull(rawOptions)
                    ? !_.isEmpty(strValue) &&
                      !hasExactSearch &&
                      !_.isEmpty(filteredOptions)
                      ? filteredOptions
                      : rawOptions
                    : []
                );
              } else {
                event.preventDefault();
              }
            }}
            disabled={disabled}
            autocomplete="off"
            onIonFocus={() => {
              setHasFocus(true);
              setIsOpen(true);
            }}
            onIonBlur={() => {
              console.log("BLURRING!!! ", itemGettingClicked);
              if (!itemGettingClicked) {
                setIsOpen(false);
              }
              setHasFocus(false);
            }}
            {...(disableTab && {
              onKeyDown: (event: React.KeyboardEvent) => {
                if (event.keyCode === 9) {
                  event.preventDefault();
                }
              },
            })}
          >
            {_.isNull(options) ? (
              <IonSpinner className="mb-dropdown-spinner" />
            ) : (
              selectFromOptionsRequired && (
                <IonIcon
                  className="mb-dropdown-select-icon"
                  icon={chevronDownOutline}
                />
              )
            )}
          </IonInput>
          {!readonly &&
            !!isOpen &&
            (!_.isEmpty(
              !_.isNull(listOptions)
                ? listOptions
                : !_.isNull(rawOptions)
                ? rawOptions
                : []
            ) ||
              !_.isEmpty(emptyOptionLabel)) && (
              <IonList
                className="mb-dropdown-select-list"
                onBlur={() => {
                  if (!selectFromOptionsRequired) {
                    setIsOpen(false);
                  }
                }}
              >
                {!_.isEmpty(listOptions) || !_.isEmpty(rawOptions) ? (
                  (!_.isNull(listOptions)
                    ? listOptions
                    : !_.isNull(rawOptions)
                    ? rawOptions
                    : []
                  ).map((item) => {
                    return (
                      <div
                        key={item.id}
                        className="mb-dropdown-select-list-container ion-no-padding ion-no-margin"
                        onClick={() => {
                          if (onSelectItem !== undefined) {
                            onSelectItem(item);
                            setItemGettingClicked(false);
                          }
                          setIsOpen(false);
                        }}
                        onMouseOver={() => {
                          setItemGettingClicked(true);
                        }}
                        onMouseLeave={() => {
                          setItemGettingClicked(false);
                        }}
                      >
                        <IonLabel className="mb-dropdown-select-list-label mb-body ion-no-padding ion-no-margin">
                          {item.name}
                        </IonLabel>
                      </div>
                    );
                  })
                ) : (
                  <div className="mb-dropdown-select-list-container ion-no-padding ion-no-margin">
                    <IonLabel className="mb-dropdown-select-list-label mb-body ion-no-padding ion-no-margin">
                      {emptyOptionLabel || ""}
                    </IonLabel>
                  </div>
                )}
              </IonList>
            )}
        </div>
      </div>
      {!!error && (
        <div className="ion-text-start">
          <IonLabel className="mb-dropdown-select-error-label mb-h6 small has-error ion ion-no-margin ion-no-padding">
            {error}
          </IonLabel>
        </div>
      )}
    </>
  );
};
